import React, { createContext, useContext, useState, useCallback } from 'react';

import { useCurrentProjectId, useUser } from '@adsk/alloy-provider';
import { useLocalState } from '@adsk/alloy-react-helpers';

import { SEARCH_MODE } from '../helpers/consts';

const SearchPanelContext = createContext({});

const useSearchPanel = () => useContext(SearchPanelContext);

const SearchPanelProvider = ({ children }) => {
  const projectId = useCurrentProjectId();
  const { user } = useUser();
  const SEARCH_SETTINGS_CACHE_KEY = `sheetsPickerSearchSettings_${projectId}_${user?.id}`;

  const [cachedSettings, setCachedSettings] = useLocalState(
    SEARCH_SETTINGS_CACHE_KEY,
    {},
  );

  const [inputText, setInputText] = useState('');
  const [setId, setSetId] = useState(null);
  const [tags, setTags] = useState([]);
  const [withAllTags, setWithAllTags] = useState(false);
  const [searchMode, setSearchMode] = useState(
    cachedSettings.searchMode || SEARCH_MODE.CURRENT,
  );

  const resetSearchPanel = useCallback(() => {
    setInputText('');
    setSetId(null);
    setTags([]);
    setWithAllTags(false);
  }, []);

  const value = {
    inputText,
    setId,
    tags,
    withAllTags,
    searchMode,
    setInputText,
    setSetId,
    setTags,
    setWithAllTags,
    setSearchMode,
    setCachedSettings,
    resetSearchPanel,
  };

  return (
    <SearchPanelContext.Provider value={value}>
      {children}
    </SearchPanelContext.Provider>
  );
};

SearchPanelProvider.displayName = 'SheetsSearchPanelProvider';

export { useSearchPanel, SearchPanelProvider };
